import { useState } from "react";
import type { Decision } from "../../api/types";
import { texte } from "../../texte";

/**
 * Fragen-Karte, gemeinsam genutzt vom Verlauf-Feed (variant="feed") und dem
 * Rückfragen-Tab (variant="tab") — Layout/Copy je Variante wie im Mockup.
 */
export function QuestionCard({
  decision,
  variant,
  onAnswer,
}: {
  decision: Decision;
  variant: "feed" | "tab";
  onAnswer: (qid: string, text: string) => void;
}) {
  const [value, setValue] = useState("");
  const [invalid, setInvalid] = useState(false);

  function submit() {
    const text = value.trim();
    if (!text) {
      setInvalid(true);
      return;
    }
    onAnswer(decision.qid, text);
  }

  return (
    <div className="fcard question">
      <span className="ico">?</span>
      <div className="body">
        {variant === "feed" ? (
          <div className="by">
            {texte.feed.questionPrefix} {decision.qid} · {texte.decisions.askedBy} {decision.asked_by}
          </div>
        ) : (
          <div className="by">
            {decision.qid} ({decision.answer ? texte.decisions.answered : texte.decisions.open}) ·{" "}
            {texte.decisions.askedBy} {decision.asked_by} {texte.decisions.at} {decision.asked_at}
          </div>
        )}
        <p className="q">{decision.question}</p>
        {decision.answer ? (
          <div className="answered">
            <b>{variant === "feed" ? texte.feed.answeredBy : texte.decisions.answerLabel}</b> {decision.answer}
          </div>
        ) : (
          <>
            <textarea
              placeholder={invalid ? texte.feed.answerRequired : texte.feed.answerPlaceholder}
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                if (invalid) setInvalid(false);
              }}
            />
            <div className="arow">
              <button className="btn primary small" onClick={submit}>
                {texte.feed.answerBtn}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
